__turbopack_context__.v({
  "detailHeader": "detail-header-module-scss-module___E6Tmq__detailHeader",
  "maxLines": "detail-header-module-scss-module___E6Tmq__maxLines",
  "paragraph": "detail-header-module-scss-module___E6Tmq__paragraph",
});
